module.exports = __webpack_public_path__ + "static/img/14j.cf15460.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/14j.jpg
// module id = 93fH
// module chunks = 0